function toQueryString (obj) {
  let parts = []
  for (let i in obj) {
    if (obj.hasOwnProperty(i) && obj[i] !== 'all') {
      parts.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]))
    }
  }
  return parts.join('&')
}

export default {
  methods: {
    toQueryString
  }
}
